<template>
  <div class="main-content">
    <!-- HEADER -->
    <div class="header">
      <div class="container-fluid">
        <div class="card mt-5">
          <div class="card-body">
            <div class="row justify-content-between align-items-center">
              <div class="col-12 col-md-9 col-xl-7">
                <!-- Heading -->
                <h2>Dashboard</h2>

                <!-- Text -->
                <p class="text-muted mb-md-0">Welcome To Ugems University</p>
              </div>
            </div>
          </div>
        </div>

        <!-- TNA Dashboard Section -->
        <div class="card mt-4">
          <!-- Simplified Tabs: Dashboard & Report -->
          <b-tabs class="tna-tabs" v-model="activeTab">
            <b-tab title="Dashboard">
              <LoadingState
                v-if="isDashboardLoading"
                title="Loading dashboard data..."
                description="Please wait while the dashboard is refreshed."
              />

              <!-- Filters Section -->
              <div v-else class="dashboard-content">
              <div class="px-4 py-3">
                <div class="d-flex flex-wrap align-items-end gap-3">
                  <!-- Company Filter -->
                  <div
                    v-if="
                      isHSETrainingRole ||
                      isHROperationsSiteRole ||
                      isHROperationsJakartaRole
                    "
                    class="flex-fill"
                    style="min-width: 200px; max-width: 300px"
                  >
                    <label class="filter-label">Company</label>
                    <v-select
                      v-model="filters.company"
                      :options="companyOptions"
                      placeholder="All Company"
                      class="filter-select"
                    ></v-select>
                  </div>

                  <!-- KPLH / Non-KPLH Filter -->
                  <div
                    v-if="shouldShowEmployeeMitraTabs"
                    class="flex-fill"
                    style="min-width: 200px; max-width: 300px"
                  >
                    <label class="filter-label">Metrik KPLH</label>
                    <v-select
                      v-model="filters.kplhType"
                      :options="kplhOptions"
                      label="label"
                      :reduce="(option) => option.value"
                      placeholder="Select Type"
                      class="filter-select"
                    ></v-select>
                  </div>

                  <!-- Training Type Filter -->
                  <div
                    class="flex-fill"
                    style="min-width: 200px; max-width: 300px"
                  >
                    <label class="filter-label">Training Type</label>
                    <v-select
                      v-model="filters.trainingType"
                      :options="trainingTypeOptions"
                      label="label"
                      :reduce="(option) => option.value"
                      :clearable="false"
                      placeholder="Select Training Type"
                      class="filter-select"
                    ></v-select>
                  </div>

                  <!-- Date Range Picker Button -->
                  <div
                    class="flex-fill ms-auto"
                    style="min-width: 200px; max-width: 300px"
                  >
                    <label class="filter-label">Period</label>
                    <b-button
                      variant="outline-secondary"
                      class="w-100 d-flex date-picker-btn pb-1 pt-1"
                      @click="showDatePicker = true"
                    >
                      <i class="fe fe-calendar me-2"></i>
                      {{ filters.period }}
                    </b-button>
                  </div>
                </div>
              </div>

              <!-- Summary Cards -->
              <div class="summary-section px-4 py-3">
                <div class="row">
                  <!-- Total Planned -->
                  <div class="col-12 col-md-4 mb-3">
                    <div class="summary-card h-100">
                      <div class="summary-content h-100">
                        <div
                          class="summary-info d-flex flex-column justify-content-between"
                        >
                          <h2 class="summary-value">
                            {{ summaryData.totalPlanned }}
                          </h2>
                          <p class="summary-label mb-0">
                            Total Planned (Number of TNA Submission)
                          </p>
                          <!-- <span class="summary-change">
                            <i class="fe fe-trending-up positive"></i>
                            {{ summaryData.plannedChange }} this month
                          </span> -->
                        </div>
                        <div class="summary-icon planned align-self-start">
                          <i class="fe fe-users"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Total Actual -->
                  <div class="col-12 col-md-4 mb-3">
                    <div class="summary-card h-100">
                      <div class="summary-content h-100">
                        <div
                          class="summary-info d-flex flex-column justify-content-between"
                        >
                          <h2 class="summary-value">
                            {{ summaryData.totalActual }}
                          </h2>
                          <p class="summary-label mb-0">
                            Total Actual (Number of TNA Submission)
                          </p>
                          <!-- <span class="summary-change">
                            <i class="fe fe-trending-up positive"></i>
                            {{ summaryData.actualChange }} this month
                          </span> -->
                        </div>
                        <div class="summary-icon actual align-self-start">
                          <i class="fe fe-user-check"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Achieved -->
                  <div class="col-12 col-md-4 mb-3">
                    <div class="summary-card h-100">
                      <div class="summary-content h-100">
                        <div
                          class="summary-info d-flex flex-column justify-content-between"
                        >
                          <h2 class="summary-value">
                            {{ summaryData.achieved }}%
                          </h2>
                          <p class="summary-label mb-0">Achieved</p>
                          <!-- <span class="summary-change">
                            <i class="fe fe-trending-down negative"></i>
                            {{ summaryData.achievedChange }} this month
                          </span> -->
                        </div>
                        <div class="summary-icon achieved align-self-start">
                          <i class="fe fe-check-circle"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Plan vs Actual Chart -->
              <div class="chart-section px-4 py-3">
                <div class="card chart-card">
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h4 class="card-title mb-0">Plan vs Actual</h4>
                    <!-- <b-dropdown variant="link" no-caret right class="chart-menu">
                      <template #button-content>
                        <i class="fe fe-more-horizontal"></i>
                      </template>
                      <b-dropdown-item>Export</b-dropdown-item>
                      <b-dropdown-item>Refresh</b-dropdown-item>
                    </b-dropdown> -->
                  </div>
                  <div class="card-body plan-actual-chart-body">
                    <apexchart
                      type="bar"
                      height="350"
                      :options="planActualChartOptions"
                      :series="planActualSeries"
                    ></apexchart>
                  </div>
                </div>
              </div>

              <!-- Admin BIB -->
              <div
                v-if="shouldShowEmployeeMitraTabs"
                class="category-section px-4 py-3"
              >
                <div class="card mb-4">
                  <div class="card-body p-0">
                    <!-- Employee & Mitra Tabs -->
                    <b-tabs
                      class="employee-detail-tabs"
                      v-model="employeeDetailTab"
                    >
                      <b-tab title="Employee Detail">
                        <employee-detail-section
                          :company-name="
                            filters.company || 'PT Putra Adi Perkasa'
                          "
                          :kplh-type="filters.kplhType || 'KPLH'"
                          :training-type="filters.trainingType || 'all'"
                          :date-range="dateRange"
                        />
                      </b-tab>
                      <b-tab title="Mitra Detail">
                        <div
                          v-if="isRoleCompetenciesLoading"
                          class="category-section px-4 py-3"
                        >
                          <LoadingState
                            title="Loading competency data..."
                            description="Please wait while the dashboard is refreshed."
                          />
                        </div>
                        <div v-else class="category-section px-4 py-3">
                          <div
                            v-if="!dashboardRoleCompetencies.length"
                            class="text-center py-4 text-muted"
                          >
                            No data available
                          </div>
                          <div v-else class="row">
                            <div
                              v-for="role in dashboardRoleCompetencies"
                              :key="role.id || role.role_competency_id"
                              class="mb-4"
                              :class="
                                getRoleCompetencyClass(
                                  role.competency || role.role_competency_title,
                                )
                              "
                            >
                              <div class="card category-card h-100">
                                <div
                                  class="card-header d-flex justify-content-between align-items-center bg-transparent border-0 pt-4 px-4 pb-0"
                                >
                                  <h4 class="card-title mb-0 font-weight-bold">
                                    {{ role.competency || role.role_competency_title }}
                                  </h4>
                                </div>
                                <div class="card-body px-4 pb-4 pt-2">
                                  <div
                                    v-if="
                                      isMinimalistCard(
                                        role.competency || role.role_competency_title,
                                      )
                                    "
                                    class="row align-items-center"
                                  >
                                    <div class="col-5 pl-0">
                                      <div class="progress-circle-wrapper">
                                        <apexchart
                                          type="radialBar"
                                          height="180"
                                          :options="
                                            getRadialChartOptions(role.total, '#E53935')
                                          "
                                          :series="[Number(role.total) || 0]"
                                        ></apexchart>
                                        <span
                                          class="progress-label font-weight-bold text-dark"
                                          style="color: #000 !important"
                                          >Total</span
                                        >
                                      </div>
                                    </div>
                                    <div class="col-7">
                                      <div class="sub-category-item rounded mb-3">
                                        <div class="d-flex justify-content-between mb-2">
                                          <span class="text-muted">Plan</span>
                                          <span class="font-weight-bold">{{
                                            role.plan
                                          }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                          <span class="text-muted">Actual</span>
                                          <span class="font-weight-bold">{{
                                            role.actual
                                          }}</span>
                                        </div>
                                      </div>
                                      <button
                                        v-if="canViewCompanyDetail"
                                        class="btn btn-block btn-outline-primary d-flex justify-content-between"
                                        @click.prevent="
                                          viewDetail(
                                            role.competency || role.role_competency_title,
                                            getFirstTraining(role),
                                          )
                                        "
                                      >
                                        Detail <i class="fe fe-arrow-right"></i>
                                      </button>
                                    </div>
                                  </div>

                                  <div v-else class="row align-items-center">
                                    <div class="col-12 col-md-3 text-center mb-3 mb-md-0">
                                      <div class="progress-circle-wrapper">
                                        <apexchart
                                          type="radialBar"
                                          height="180"
                                          :options="
                                            getRadialChartOptions(role.total, '#E53935')
                                          "
                                          :series="[Number(role.total) || 0]"
                                        ></apexchart>
                                        <span class="progress-label">Total</span>
                                      </div>
                                    </div>
                                    <div class="col-12 col-md-9">
                                      <div class="row">
                                        <div
                                          v-for="(training, index) in (role.trainings || [])"
                                          :key="index"
                                          class="col-12 col-md-4 mb-3"
                                        >
                                          <div class="sub-category-item">
                                            <div
                                              class="d-flex justify-content-between align-items-center mb-2"
                                            >
                                              <span class="sub-category-name">{{
                                                training.name
                                              }}</span>
                                              <span class="sub-category-percentage"
                                                >{{ training.percentage }}%</span
                                              >
                                            </div>
                                            <b-progress
                                              :value="training.percentage"
                                              :max="100"
                                              :variant="
                                                getProgressVariant(training.percentage)
                                              "
                                              height="8px"
                                            ></b-progress>
                                            <div class="mt-3">
                                              <div
                                                class="d-flex justify-content-between mb-2"
                                              >
                                                <span class="text-muted">Plan</span>
                                                <span class="font-weight-bold">{{
                                                  training.plan || training.submitted
                                                }}</span>
                                              </div>
                                              <div class="d-flex justify-content-between">
                                                <span class="text-muted">Actual</span>
                                                <span class="font-weight-bold">{{
                                                  training.actual || training.completed
                                                }}</span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="mt-3" v-if="canViewCompanyDetail">
                                        <button
                                          class="btn btn-block btn-outline-primary d-flex justify-content-between"
                                          @click.prevent="
                                            viewDetail(
                                              role.competency ||
                                                role.role_competency_title,
                                              getFirstTraining(role),
                                            )
                                          "
                                        >
                                          Detail <i class="fe fe-arrow-right"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>

              <!-- Compentency Sections -->
              <div
                v-if="shouldShowRoleCompetencySection && isRoleCompetenciesLoading"
                class="category-section px-4 py-3"
              >
                <LoadingState
                  title="Loading competency data..."
                  description="Summary and chart are ready while this section is refreshed."
                />
              </div>

              <!-- HR Operations (Site & Jakarta) -->
              <div
                v-else-if="isHROpsRole && filters.kplhType == 'NON_KPLH'"
                class="category-section px-4 py-3"
              >
                <div class="row">
                  <div
                    v-for="role in dashboardRoleCompetencies"
                    :key="role.id || role.role_competency_id"
                    class="mb-4"
                    :class="
                      getRoleCompetencyClass(
                        role.competency || role.role_competency_title,
                      )
                    "
                  >
                    <div class="card category-card h-100">
                      <div
                        class="card-header d-flex justify-content-between align-items-center bg-transparent border-0 pt-4 px-4 pb-0"
                      >
                        <h4 class="card-title mb-0 font-weight-bold">
                          {{ role.competency || role.role_competency_title }}
                        </h4>
                        <b-dropdown
                          variant="link"
                          no-caret
                          right
                          class="chart-menu"
                        >
                          <template #button-content>
                            <i class="fe fe-more-horizontal text-muted"></i>
                          </template>
                          <b-dropdown-item>View Details</b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <div class="card-body px-4 pb-4 pt-2">
                        <!-- Minimalist Layout (Technical & Managerial) -->
                        <div
                          v-if="
                            isMinimalistCard(
                              role.competency || role.role_competency_title,
                            )
                          "
                          class="row align-items-center"
                        >
                          <!-- Left: Radial Chart -->
                          <div class="col-5 pl-0">
                            <div class="progress-circle-wrapper">
                              <apexchart
                                type="radialBar"
                                height="180"
                                :options="
                                  getRadialChartOptions(role.total, '#E53935')
                                "
                                :series="[Number(role.total) || 0]"
                              ></apexchart>
                              <span
                                class="progress-label font-weight-bold text-dark"
                                style="color: #000 !important"
                                >Total</span
                              >
                            </div>
                          </div>
                          <!-- Right: Plan/Actual & Button -->
                          <div class="col-7">
                            <div class="sub-category-item rounded mb-3">
                              <div class="d-flex justify-content-between mb-2">
                                <span class="text-muted">Plan</span>
                                <span class="font-weight-bold">{{
                                  role.plan
                                }}</span>
                              </div>
                              <div class="d-flex justify-content-between">
                                <span class="text-muted">Actual</span>
                                <span class="font-weight-bold">{{
                                  role.actual
                                }}</span>
                              </div>
                            </div>
                            <button
                              class="btn btn-block btn-outline-primary d-flex justify-content-between"
                              @click.prevent="
                                viewDetail(
                                  role.competency || role.role_competency_title,
                                  getFirstTraining(role),
                                )
                              "
                            >
                              Detail <i class="fe fe-arrow-right"></i>
                            </button>
                          </div>
                        </div>

                        <!-- Standard Layout (Annually Fulfillment) -->
                        <div v-else class="row align-items-center">
                          <div class="col-12 col-md-3 text-center mb-3 mb-md-0">
                            <div class="progress-circle-wrapper">
                              <apexchart
                                type="radialBar"
                                height="180"
                                :options="
                                  getRadialChartOptions(role.total, '#E53935')
                                "
                                :series="[Number(role.total) || 0]"
                              ></apexchart>
                              <span class="progress-label">Total</span>
                            </div>
                          </div>
                          <div class="col-12 col-md-9">
                            <div class="row">
                              <div
                                v-for="(training, index) in (role.trainings || [])"
                                :key="index"
                                class="col-12 col-md-4 mb-3"
                              >
                                <div class="sub-category-item">
                                  <div
                                    class="d-flex justify-content-between align-items-center mb-2"
                                  >
                                    <span class="sub-category-name">{{
                                      training.name
                                    }}</span>
                                    <span class="sub-category-percentage"
                                      >{{ training.percentage }}%</span
                                    >
                                  </div>
                                  <b-progress
                                    :value="training.percentage"
                                    :max="100"
                                    :variant="
                                      getProgressVariant(training.percentage)
                                    "
                                    height="8px"
                                  ></b-progress>
                                  <div class="mt-3">
                                    <div
                                      class="d-flex justify-content-between mb-2"
                                    >
                                      <span class="text-muted">Plan</span>
                                      <span class="font-weight-bold">{{
                                        training.plan || training.submitted
                                      }}</span>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                      <span class="text-muted">Actual</span>
                                      <span class="font-weight-bold">{{
                                        training.actual || training.completed
                                      }}</span>
                                    </div>
                                  </div>
                                  <!-- <div class="d-flex justify-content-between mt-2">
                                     <span class="sub-category-detail">Plan <strong>{{ training.plan || training.submitted }}</strong></span>
                                     <span class="sub-category-detail">Actual <strong>{{ training.actual || training.completed }}</strong></span>
                                   </div> -->
                                </div>
                              </div>
                            </div>
                            <div class="mt-3">
                              <button
                                class="btn btn-block btn-outline-primary d-flex justify-content-between"
                                @click.prevent="
                                  viewDetail(
                                    role.competency ||
                                      role.role_competency_title,
                                    getFirstTraining(role),
                                  )
                                "
                              >
                                Detail <i class="fe fe-arrow-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Admin Mitra & Admin PJO & hse training (Original Layout) -->
              <div v-else-if="shouldShowRoleCompetencySection" class="category-section px-4 py-3">
                <!-- Loop through all role competency items -->
                <div
                  v-for="role in dashboardRoleCompetencies"
                  :key="role.role_competency_id"
                  class="card category-card mb-4"
                >
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h4 class="card-title mb-0">
                      {{ role.role_competency_title }}
                    </h4>
                    <!-- <b-dropdown variant="link" no-caret right class="chart-menu">
                      <template #button-content>
                        <i class="fe fe-more-horizontal"></i>
                      </template>
                      <b-dropdown-item>View Details</b-dropdown-item>
                      <b-dropdown-item>Export</b-dropdown-item>
                    </b-dropdown> -->
                  </div>
                  <div class="card-body">
                    <!-- Complex Type: Has Sub-Categories -->
                    <div class="row align-items-center">
                      <!-- Total Circle -->
                      <div class="col-12 col-md-3 text-center mb-3 mb-md-0">
                        <div class="progress-circle-wrapper">
                          <apexchart
                            type="radialBar"
                            height="180"
                            :options="
                              getRadialChartOptions(role.total, '#E53935')
                            "
                            :series="[Number(role.total) || 0]"
                          ></apexchart>
                          <span class="progress-label">Total</span>
                        </div>
                      </div>

                      <!-- Sub Categories -->
                      <div class="col-12 col-md-9">
                        <div class="row">
                          <div
                            v-for="(training, index) in (role.trainings || [])"
                            :key="index"
                            class="col-12 col-md-4 mb-3"
                          >
                            <div class="sub-category-item">
                              <div
                                class="d-flex justify-content-between align-items-center mb-2"
                              >
                                <span class="sub-category-name">{{
                                  training.name
                                }}</span>
                                <span class="sub-category-percentage"
                                  >{{ training.percentage }}%</span
                                >
                              </div>
                              <b-progress
                                :value="training.percentage"
                                :max="100"
                                :variant="
                                  getProgressVariant(training.percentage)
                                "
                                height="8px"
                              ></b-progress>
                              <div class="mt-3">
                                <div
                                  class="d-flex justify-content-between mb-2"
                                >
                                  <span class="text-muted">Plan</span>
                                  <span class="font-weight-bold">{{
                                    training.submitted
                                  }}</span>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <span class="text-muted">Actual</span>
                                  <span class="font-weight-bold">{{
                                    training.completed
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-3">
                          <button
                            class="btn btn-block btn-outline-primary d-flex justify-content-between"
                            @click.prevent="
                              viewDetail(
                                role.role_competency_title,
                                getFirstTraining(role),
                              )
                            "
                          >
                            Detail <i class="fe fe-arrow-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </b-tab>

            <b-tab title="Report">
              <div class="report-section px-4 py-3">
                <!-- Report Filters Row 1: Report Type & Period -->
                <div class="row mb-4">
                  <!-- Success Display -->
                  <div
                    v-if="exportSuccess"
                    class="alert alert-success mt-3 mb-0 d-flex align-items-center"
                  >
                    <i class="fe fe-check-circle me-2"></i>
                    <div><strong>Success!</strong> {{ exportSuccess }}</div>
                  </div>

                  <!-- Error Display -->
                  <div
                    v-if="exportError"
                    class="alert alert-danger mt-3 mb-0 d-flex align-items-center"
                  >
                    <i class="fe fe-alert-circle me-2"></i>
                    <div><strong>Error!</strong> {{ exportError }}</div>
                  </div>
                </div>
                <div class="row mb-4">
                  <!-- Left: Report Type Selection -->
                  <div class="col-12 col-lg-6 mb-3 mb-lg-0">
                    <div class="card h-100">
                      <div class="card-header">
                        <h6 class="mb-0">
                          Report Type <span class="text-danger">*</span>
                        </h6>
                      </div>
                      <div class="card-body">
                        <v-select
                          v-model="reportFilters.reportType"
                          :options="reportTypeOptions"
                          placeholder="Select Report Type"
                          :reduce="(option) => option"
                          label="label"
                          class="report-type-select"
                        >
                          <template #no-options>
                            <span>No report types available</span>
                          </template>
                        </v-select>
                      </div>
                    </div>
                  </div>

                  <!-- Right: Period & Date Range -->
                  <div class="col-12 col-lg-6">
                    <div class="card h-100">
                      <div class="card-header">
                        <h6 class="mb-0">
                          Period <span class="text-danger">*</span>
                        </h6>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <!-- Period Quick Filter -->
                          <div class="col-12 mb-3">
                            <label class="filter-label">Quick Period</label>
                            <v-select
                              v-model="reportFilters.period"
                              :options="reportPeriodOptions"
                              placeholder="Select Period"
                              class="filter-select"
                              @input="updateReportDateRange"
                            ></v-select>
                          </div>

                          <!-- Start Date -->
                          <div class="col-12 col-md-6 mb-3 mb-md-0">
                            <label class="filter-label"
                              >Start Date
                              <span class="text-danger">*</span></label
                            >
                            <b-form-datepicker
                              v-model="reportFilters.startDate"
                              placeholder="Select Start Date"
                              :date-format-options="{
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                              }"
                              locale="en"
                            ></b-form-datepicker>
                          </div>

                          <!-- End Date -->
                          <div class="col-12 col-md-6">
                            <label class="filter-label"
                              >End Date
                              <span class="text-danger">*</span></label
                            >
                            <b-form-datepicker
                              v-model="reportFilters.endDate"
                              placeholder="Select End Date"
                              :date-format-options="{
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                              }"
                              :min="reportFilters.startDate"
                              locale="en"
                            ></b-form-datepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Report Filters Row 2: Optional Filters -->
                <div class="card mb-4">
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h6 class="mb-0">Additional Filters</h6>
                    <small class="text-muted">(Optional)</small>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Company Filter -->
                      <div
                        v-if="showReportCompanyFilter"
                        class="col-12 col-md-6 mb-3 mb-md-0"
                      >
                        <label class="filter-label">Company</label>
                        <v-select
                          v-model="reportFilters.company"
                          :options="companyOptions"
                          placeholder="All Company"
                          class="filter-select"
                          :clearable="true"
                        ></v-select>
                      </div>

                      <!-- Competency Filter -->
                      <div
                        v-if="showReportCompetencyFilter"
                        :class="showReportCompanyFilter ? 'col-12 col-md-6' : 'col-12'"
                      >
                        <label class="filter-label">Competency</label>
                        <v-select
                          v-model="reportFilters.competency"
                          :options="reportCompetencyOptions"
                          :reduce="(option) => option.value"
                          label="label"
                          placeholder="Select Competency"
                          class="filter-select"
                          :clearable="true"
                          :loading="isLoadingCompetencyOptions"
                        ></v-select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Export Button -->
                <div class="mb-4 text-right">
                  <b-button
                    variant="danger"
                    size="md"
                    @click="exportReport"
                    :disabled="isExporting"
                    class="px-4"
                  >
                    <b-spinner
                      small
                      v-if="isExporting"
                      class="me-2"
                    ></b-spinner>
                    <i v-else class="fe fe-download me-2"></i>
                    {{ isExporting ? "Exporting..." : "Export Report" }}
                  </b-button>
                </div>

                <!-- Report Table (Commented Out) -->
                <!-- 
                <div class="card">
                  <div class="card-header">
                    <h6 class="mb-0">Report Preview</h6>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <b-table
                        :items="reportData"
                        :fields="reportTableFields"
                        :current-page="reportCurrentPage"
                        :per-page="reportPerPage"
                        striped
                        hover
                        class="report-table mb-0"
                      >
                        <template #cell(no)="data">
                          {{
                            (reportCurrentPage - 1) * reportPerPage +
                            data.index +
                            1
                          }}
                        </template>

                        <template #cell(percentage)="data">
                          <span v-if="data.item.percentage !== 'N/A'">
                            {{ data.item.percentage }}
                          </span>
                          <span v-else class="text-muted">N/A</span>
                        </template>
                      </b-table>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="d-flex justify-content-end align-items-center">
                      <b-pagination
                        v-model="reportCurrentPage"
                        :total-rows="reportTotalRows"
                        :per-page="reportPerPage"
                        size="sm"
                        class="mb-0"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
                -->
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>

    <!-- Date Picker Modal Component -->
    <DatePickerModal
      :visible="showDatePicker"
      :initial-period="filters.period"
      :initial-start-date="dateRange.start"
      :initial-end-date="dateRange.end"
      @close="closeDatePicker"
      @apply="applyDateRange"
    />

    <!-- Detail Modal Component -->
    <DetailModal
      :visible="showDetailModal"
      :selected-role="selectedRole"
      :selected-sub-category="selectedSubCategory"
      :company-name="filters.company"
      :date-range="dateRange"
      :is-partner-role="isPartnerRole"
      :is-h-s-e-training-role="isHSETrainingRole"
      :is-employee-role="isEmployeeRole"
      :is-manager-role="isManagerRole"
      :is-h-r-operations-site-role="isHROperationsSiteRole"
      :is-h-r-operations-jakarta-role="isHROperationsJakartaRole"
      :kplh-type="filters.kplhType"
      :training-type="filters.trainingType || 'all'"
      @close="closeDetailModal"
    />
  </div>
</template>

<script>
import logic from "./dashboard.logic.js";

export default {
  ...logic,
};
</script>

<style src="./dashboard.css" scoped></style>
